import React from "react";
import "../styles/departments.css"

const Department=()=>{

    return(
        <>
        <div className="department">
            
        </div>
        </>
    )
}

export default Department